module.exports = __webpack_public_path__ + "Booking.png";